export default __webpack_public_path__ + "static/canine_acl_tear_tplo-d711876223dbc0aa879db416c13353bb.png";